import apiService, { buildQueryString } from './api';
class MovimentacoesService {
    // Listar movimentações
    async list(filters = {}) {
        const queryString = buildQueryString(filters);
        const response = await apiService.get(`/movimentacoes${queryString}`);
        return response.data;
    }
    // Buscar movimentação por ID
    async getById(id) {
        const response = await apiService.get(`/movimentacoes/${id}`);
        return response.data;
    }
    // Criar movimentação
    async create(data) {
        const response = await apiService.post('/movimentacoes', data);
        return response.data;
    }
    // Ajustar estoque
    async ajustarEstoque(data) {
        const response = await apiService.post('/movimentacoes/ajuste', data);
        return response.data;
    }
    // Obter relatório
    async getRelatorio(filters = {}) {
        const queryString = buildQueryString(filters);
        const response = await apiService.get(`/movimentacoes/relatorio${queryString}`);
        return response.data;
    }
    // Exportar movimentações
    async exportar(format, filters = {}) {
        const queryString = buildQueryString({ ...filters, format });
        await apiService.download(`/movimentacoes/exportar${queryString}`, `movimentacoes-estoque.${format}`);
    }
    // Buscar movimentações por produto
    async getByProduto(produtoId, limit = 50) {
        const response = await apiService.get(`/movimentacoes?produtoId=${produtoId}&limit=${limit}`);
        return response.data.movimentacoes;
    }
    // Buscar movimentações recentes
    async getRecentes(limit = 20) {
        const response = await apiService.get(`/movimentacoes?limit=${limit}`);
        return response.data.movimentacoes;
    }
    // Buscar movimentações por usuário
    async getByUsuario(usuarioId, limit = 50) {
        const response = await apiService.get(`/movimentacoes?usuarioId=${usuarioId}&limit=${limit}`);
        return response.data.movimentacoes;
    }
    // Buscar movimentações por tipo
    async getByTipo(tipo, limit = 50) {
        const response = await apiService.get(`/movimentacoes?tipo=${tipo}&limit=${limit}`);
        return response.data.movimentacoes;
    }
    // Buscar movimentações por período
    async getByPeriodo(dataInicio, dataFim) {
        const response = await apiService.get(`/movimentacoes?dataInicio=${dataInicio}&dataFim=${dataFim}&limit=1000`);
        return response.data.movimentacoes;
    }
    // Buscar movimentações de ordem de serviço
    async getByOrdemServico(ordemServicoId) {
        const response = await apiService.get(`/movimentacoes?ordemServicoId=${ordemServicoId}&limit=100`);
        return response.data.movimentacoes;
    }
    // Validar movimentação antes de criar
    async validarMovimentacao(data) {
        try {
            // Buscar produto para verificar estoque atual
            const produtoResponse = await apiService.get(`/produtos/${data.produtoId}`);
            const produto = produtoResponse.data;
            if (!produto.ativo) {
                return { valida: false, erro: 'Produto inativo' };
            }
            if (data.tipo === 'SAIDA' && produto.stockAtual < data.quantidade) {
                return {
                    valida: false,
                    erro: `Estoque insuficiente. Disponível: ${produto.stockAtual}, Solicitado: ${data.quantidade}`,
                    produto
                };
            }
            return { valida: true, produto };
        }
        catch (error) {
            return { valida: false, erro: 'Produto não encontrado' };
        }
    }
}
// Instância singleton
const movimentacoesService = new MovimentacoesService();
export default movimentacoesService;
// Utilitários
export const tiposMovimentacao = [
    { value: 'ENTRADA', label: 'Entrada', color: 'green', icon: '📥', description: 'Adição de produtos ao estoque' },
    { value: 'SAIDA', label: 'Saída', color: 'red', icon: '📤', description: 'Remoção de produtos do estoque' },
    { value: 'AJUSTE', label: 'Ajuste', color: 'blue', icon: '⚖️', description: 'Correção de estoque por inventário' }
];
export const getTipoMovimentacaoConfig = (tipo) => {
    return tiposMovimentacao.find(t => t.value === tipo) || tiposMovimentacao[0];
};
export const formatarTipoMovimentacao = (tipo) => {
    const config = getTipoMovimentacaoConfig(tipo);
    return config.label;
};
export const getTipoMovimentacaoColor = (tipo) => {
    const config = getTipoMovimentacaoConfig(tipo);
    return config.color;
};
export const getTipoMovimentacaoIcon = (tipo) => {
    const config = getTipoMovimentacaoConfig(tipo);
    return config.icon;
};
export const formatarQuantidade = (quantidade, tipo) => {
    const formatted = new Intl.NumberFormat('pt-PT').format(quantidade);
    switch (tipo) {
        case 'ENTRADA':
            return `+${formatted}`;
        case 'SAIDA':
            return `-${formatted}`;
        case 'AJUSTE':
            return formatted;
        default:
            return formatted;
    }
};
export const formatarDiferencaEstoque = (estoqueAnterior, estoqueAtual) => {
    const diferenca = estoqueAtual - estoqueAnterior;
    const formatted = new Intl.NumberFormat('pt-PT').format(Math.abs(diferenca));
    if (diferenca > 0) {
        return `+${formatted}`;
    }
    else if (diferenca < 0) {
        return `-${formatted}`;
    }
    else {
        return '0';
    }
};
export const formatarDataMovimentacao = (data) => {
    return new Date(data).toLocaleDateString('pt-PT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
};
export const calcularTotalMovimentacoes = (movimentacoes) => {
    return movimentacoes.reduce((acc, mov) => {
        switch (mov.tipo) {
            case 'ENTRADA':
                acc.totalEntradas++;
                acc.quantidadeEntradas += mov.quantidade;
                break;
            case 'SAIDA':
                acc.totalSaidas++;
                acc.quantidadeSaidas += mov.quantidade;
                break;
            case 'AJUSTE':
                acc.totalAjustes++;
                break;
        }
        return acc;
    }, {
        totalEntradas: 0,
        totalSaidas: 0,
        totalAjustes: 0,
        quantidadeEntradas: 0,
        quantidadeSaidas: 0
    });
};
export const obterMotivosMovimentacao = () => [
    { tipo: 'ENTRADA', motivos: [
            'Compra de fornecedor',
            'Devolução de cliente',
            'Transferência entre lojas',
            'Produção interna',
            'Ajuste de inventário',
            'Outros'
        ] },
    { tipo: 'SAIDA', motivos: [
            'Venda para cliente',
            'Uso em ordem de serviço',
            'Transferência entre lojas',
            'Produto danificado',
            'Amostra grátis',
            'Outros'
        ] },
    { tipo: 'AJUSTE', motivos: [
            'Inventário físico',
            'Correção de erro',
            'Produto encontrado',
            'Produto perdido',
            'Outros'
        ] }
];
export const validarQuantidadeMovimentacao = (quantidade, tipo) => {
    if (quantidade <= 0) {
        return { valida: false, erro: 'Quantidade deve ser maior que zero' };
    }
    if (!Number.isInteger(quantidade)) {
        return { valida: false, erro: 'Quantidade deve ser um número inteiro' };
    }
    if (quantidade > 999999) {
        return { valida: false, erro: 'Quantidade muito alta (máximo: 999.999)' };
    }
    return { valida: true };
};
